// extracted by mini-css-extract-plugin
module.exports = {"chart":"V4IFOE","name":"_1tFZP6","mapCanvas":"_3vlfXN","mainCanvas":"_19d6EC","toggles":"_21E_Df","toggle":"_3B3XYo"};